import PageKit from '../PageKit';
import WhiteSpace from '../component/WhiteSpace';
import { useTranslation } from 'react-i18next';
import '../component/componentCss/LegalPage.css';  

function MentionsLegales() {
  const { t } = useTranslation();

  const sections = [
    { title: t('LegalMentions.SitePublisherTitle'), content: t('LegalMentions.SitePublisherContent') },
    { title: t('LegalMentions.HostingTitle'), content: t('LegalMentions.HostingContent') },
    { title: t('LegalMentions.IntellectualPropertyTitle'), content: t('LegalMentions.IntellectualPropertyContent') },
    { title: t('LegalMentions.ResponsibilityTitle'), content: t('LegalMentions.ResponsibilityContent') },
    { title: t('LegalMentions.ContactTitle'), content: t('LegalMentions.ContactContent') },
    { title: t('LegalMentions.PrivacyTitle'), content: t('LegalMentions.PrivacyContent') }
  ];

  return (
    <PageKit>
      <section className="legalContent">
        <h1 className="legalPageTitle">{t('LegalMentions.Title')}</h1>
        {sections.map((section, index) => (
          <div key={index} className="legalSection">
            <h2 className="legalSectionTitle">{section.title}</h2>
            <p className="legalSectionContent">{section.content}</p>
          </div>
        ))}
        <WhiteSpace height={100} />
      </section>
    </PageKit>
  );
}

export default MentionsLegales;
